import React from 'react'
import classes from './common.module.scss'

export const Text = (props: any) => <p className={classes.text} {...props} />
